var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailBubble = function SvgEmailBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5031 16.384L20.5001 20.382L28.4971 16.384C28.4674 15.8744 28.2441 15.3955 27.8729 15.0452C27.5016 14.695 27.0105 14.4999 26.5001 14.5H14.5001C13.9896 14.4999 13.4985 14.695 13.1272 15.0452C12.756 15.3955 12.5327 15.8744 12.5031 16.384Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18.618L20.5 22.618L12.5 18.618V24.5C12.5 25.0304 12.7107 25.5391 13.0858 25.9142C13.4609 26.2893 13.9696 26.5 14.5 26.5H26.5C27.0304 26.5 27.5391 26.2893 27.9142 25.9142C28.2893 25.5391 28.5 25.0304 28.5 24.5V18.618Z",
    fill: "#919191"
  })));
};
export default SvgEmailBubble;